import { defineComponent, openBlock, createElementBlock, createElementVNode, normalizeClass, toDisplayString, createBlock, unref, withCtx, createTextVNode, createCommentVNode } from "vue";
import { CdrLink } from "@rei/cedar";
const _hoisted_1 = {
  class: "pickup-context"
};
const _hoisted_2 = {
  class: "pickup-context__message"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxPickupContext",
  props: {
    available: {
      type: Boolean,
      default: false
    },
    boldMessage: {
      default: ""
    },
    message: {
      default: ""
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showInStockInModal: {
      type: Boolean,
      default: true
    }
  },
  emits: ["storeFinderClick"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = createElementVNode("span", {
        class: "pickup-context__title"
      }, " Find it in store ", -1)), createElementVNode("span", {
        class: normalizeClass(["pickup-context__message--bold", {
          "pickup-context__message--available": _ctx.available
        }])
      }, toDisplayString(_ctx.boldMessage), 3), createElementVNode("span", _hoisted_2, toDisplayString(_ctx.message), 1), _ctx.showEdit ? (openBlock(), createBlock(unref(CdrLink), {
        key: 0,
        class: "pickup-context__change-store",
        tag: "button",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("storeFinderClick", _ctx.showInStockInModal))
      }, {
        default: withCtx(() => _cache[1] || (_cache[1] = [createTextVNode(" Check other stores ")])),
        _: 1,
        __: [1]
      })) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxPickupContext2.mjs.map
